module.exports = {
    
    //my cart
    
    FETCH_CART_LIST: 'FETCH_CART_LIST',
    GET_ERRORS_CART_LIST: 'GET_ERRORS_CART_LIST',
    CLEAR_CARTLIST: 'CLEAR_CARTLIST'
}